module.exports = __webpack_public_path__ + "img/reorder-new-icon.0dc1e178.svg";